import React from 'react';
import classNames from 'classnames';
import Grid from '@havenengineering/module-shared-library/dist/components/Grid';
import { useRouter } from 'next/router';

import styles from './aggregating-search-header.module.scss';
import { AggregatedStepper } from '../aggregated-stepper/aggregated-stepper';
import Heading from '../heading/heading';
import { canShare } from '../../helper/share-page';
import useScreenSize from '../../hook/use-screen-size/use-screen-size';
import { SearchNavigator } from '../search-navigator/search-navigator';
import { useUnleash } from '../../../../providers/unleashProvider';

type Props = {
  title?: string;
  subTitle?: string;
  showShortlistingButton?: boolean;
  activeStep: string;
  customComponent?: React.ReactElement;
};

export const AggregatingSearchHeader = ({
  title,
  subTitle,
  showShortlistingButton,
  activeStep,
  customComponent,
}: Props) => {
  const { query } = useRouter();
  const screenSize = useScreenSize();
  const { isUnleashVariantActiveCsr } = useUnleash();
  const isOnMobile = screenSize === 'mobile';
  const navigatorV2 = isUnleashVariantActiveCsr('search-414-navigator-v2', '1', query);
  const hideTitleOnMobile = activeStep === 'Date' && isOnMobile;
  return (
    <header className={styles.searchResultHeaderRoot}>
      {navigatorV2 ? (
        <SearchNavigator activeStep={activeStep} query={query} />
      ) : (
        <AggregatedStepper activeStep={activeStep} query={query} />
      )}
      {customComponent}
      {title && !hideTitleOnMobile && (
        <Grid.Container>
          <Grid.Row justify="center">
            <Grid.Col md={12} lg={6}>
              <Heading
                level={2}
                scale={2}
                className={classNames(styles.title, {
                  [styles.headerWithShortlisting]: showShortlistingButton,
                  [styles.headerWithShareButton]: canShare,
                  [styles.titleWithSubtitle]: subTitle,
                })}
                breakPoint="lg"
                margin="none"
              >
                {title}
              </Heading>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      )}
      {subTitle && (
        <Grid.Container>
          <Grid.Row justify="center">
            <Grid.Col md={12} lg={6}>
              <Heading level={3} scale={3} className={styles.subTitle}>
                {subTitle}
              </Heading>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      )}
    </header>
  );
};
